var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c("input", {
      class: _vm.styles,
      attrs: { type: "radio", id: _vm.label, name: _vm.name },
      domProps: { value: _vm.value, checked: _vm.checked },
      on: { change: _vm.handleChange },
    }),
    _c("label", { attrs: { for: _vm.label } }, [
      _vm._v(" " + _vm._s(_vm.label) + " "),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }